/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import useDemoKrpano from '../../hooks/useDemoKrpano'
import { subject } from '../../service'

const RenderTour = (props) => {
  
  
const KRPANO_XML_PATH = 'krpano/'+props.name+'/tour.xml'
const KRPANO_SCRIPT_PATH = 'krpano/'+props.name+'/tour.js'
const DEFAULT_TARGET_ID = 'react-krpano'+props.name+props.position
const DEFAULT_GLOBAL_VAR_NAME = 'reactKrpano'
    
const DEFAULT_EMBEDDING_PARAMS = {
    xml: KRPANO_XML_PATH,
    target: DEFAULT_TARGET_ID,
    html: 'prefer',
}
    
const KRPANO_TOUR = {
    default_embedding_params : DEFAULT_EMBEDDING_PARAMS,
    krpano_script_path : KRPANO_SCRIPT_PATH,
    target_id : DEFAULT_TARGET_ID,
    global_var_name : DEFAULT_GLOBAL_VAR_NAME
}
  
const {
    showLoadingPage,
    isLoaded,
    containerRef: containerRef1,
    toggleLockView,
    isLocked,
    toggleHideSpots,
    isHideSpots,
    currentScene,
    getKrpano,
    setKrpano,
  } = useDemoKrpano(KRPANO_TOUR)

  var dragging = false;

  if(props.orientation){
    setKrpano("view.hlookat", props.orientation.hlookat);
    setKrpano("view.vlookat", props.orientation.vlookat);
    setKrpano("view.fov", props.orientation.fov);
  }

  return (
    <>
      <div
        ref={containerRef1}
        onMouseDown={() => {
          dragging = true;
          subject.next({
              id: props.position,
              hlookat: getKrpano("view.hlookat"),
              vlookat: getKrpano("view.vlookat"),
              fov: getKrpano("view.fov")
            });
        }}
        onMouseUp={() => {
          dragging = false;
          subject.next({
            id: props.position,
            hlookat: getKrpano("view.hlookat"),
            vlookat: getKrpano("view.vlookat"),
            fov: getKrpano("view.fov")
          })
        }}
        onMouseMove={() => {
          if(dragging){
            subject.next({
              id: props.position,
              hlookat: getKrpano("view.hlookat"),
              vlookat: getKrpano("view.vlookat"),
              fov: getKrpano("view.fov")
            })
          }
        }}
      />
    </>
  )
}

export default RenderTour



